export default {"src":"/_next/static/media/arrow.4416f3ba.svg","height":18,"width":25,"blurWidth":0,"blurHeight":0};